import React, { useEffect, useState } from "react";
import { useParams } from "react-router";
import { useWindowSize } from "../../../../../Helpers";
import { useResolvedGameData } from "../../../resolveGameData";
import Button from "@components/Button";
import "./style.scss";
import LinearGradientProgressBar from "@components/LinearGradientProgressBar";
import StickyButton from "../../../../../components/StickyButton";
import PagesHeader from "@components/PagesHeader";
import StickyContent from "@components/StickyContent";
import BrandLogo from "@components/BrandLogo";
import DOMPurify from "dompurify";

export default function Poll({
  currentQuestion,
  setCurrentQuestion,
  setAnswers,
  answers,
  sendAnswers,
  data,
}) {
  const { ident } = useParams();
  const { width } = useWindowSize();
  const gameQuestionsQuery = useResolvedGameData(answers);

  const itsCompleted = data?.completed;
  const XGA = width >= 1020;
  const [selected, setSelected] = useState(-1);
  const [inputValues, setInputValues] = useState("");

  const itsTextarea =
    gameQuestionsQuery.content[currentQuestion].answers[selected]?.textarea ??
    false;

  const needToSelect = selected === -1;
  gameQuestionsQuery.content[currentQuestion].answers[selected]?.ident ?? "";
  const selectedAnswerIdent =
    gameQuestionsQuery.content[currentQuestion].answers[selected]?.ident;
  const handleInputChange = (value) => {
    setInputValues(value);
  };

  const canProceed =
    (!needToSelect && !itsTextarea) || (itsTextarea && inputValues);

  const handleAnswerClick = (index) => {
    setSelected(index);
    console.log(answers, "answ");
  };

  const resetInputs = () => {
    setInputValues("");
    setSelected(-1);
  };

  const handleNextButtonClick = async () => {
    if (!canProceed) return;
    const updatedAnswers = {
      question_ident: gameQuestionsQuery.content[currentQuestion].ident,
      answer_ident: itsTextarea ? inputValues : selectedAnswerIdent,
    };

    setAnswers((prevAnswers) => {
      const newAnswers = [...prevAnswers, updatedAnswers];
      return newAnswers;
    });
  };

  useEffect(() => {
    if (answers.length > 0) {
      if (canProceed) {
        setCurrentQuestion((prev) => prev + 1);
        resetInputs();
      }
    }
    if (gameQuestionsQuery.answersNumber === answers.length) {
      sendAnswers();
    }
  }, [answers]);

  return (
    <section className={`game-page quiz-mechanics ${ident}`}>
      <div>
        <PagesHeader back>
          <p
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(gameQuestionsQuery?.title),
            }}
          ></p>
        </PagesHeader>
        <div className="main-game-wrppaer">
          <div className="desktop-wrapper">
            <LinearGradientProgressBar
              value={currentQuestion / gameQuestionsQuery.content.length}
            />
            <div className="game-question">
              <h2
                className="question"
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(gameQuestionsQuery.content[currentQuestion].question),
                }}
              />
            </div>
            <div className={`answer-content ${ident}`}>
              <div className="answers-wrapper">
                {gameQuestionsQuery.content[currentQuestion].answers.map(
                  ({ answer, textarea }, index) => (
                    <div key={index}>
                      {textarea ? (
                        <>
                          <button
                            className={`answer ${
                              index === selected ? "selected" : ""
                            }`}
                            disabled={itsCompleted}
                            key={index}
                            onClick={() => handleAnswerClick(index)}
                          >
                            <div className="inner">
                              <span className="oval" />
                              {answer?.textImage ? (
                                <>
                                  <img src={answer.textImage.img} alt="" />
                                  <p>{answer.textImage.text}</p>
                                </>
                              ) : gameQuestionsQuery.content[currentQuestion]
                                  .imgAnswers ? (
                                <img
                                  alt="answerIMG"
                                  src={answer}
                                  className="answerImg"
                                ></img>
                              ) : (
                                <p>{answer}</p>
                              )}
                            </div>
                          </button>
                          {selected === index && (
                            <>
                              <textarea
                                disabled={itsCompleted}
                                className="answer-textarea"
                                value={inputValues}
                                onChange={(e) =>
                                  handleInputChange(e.target.value)
                                }
                                autoFocus
                                placeholder="Geben Sie Ihre eigene Antwort ein"
                                maxLength={500}
                              />
                              <div className="limit">
                                {" "}
                                {inputValues?.length || 0} / 500
                              </div>
                            </>
                          )}
                        </>
                      ) : (
                        <button
                          className={`answer ${
                            index === selected ? "selected" : ""
                          }`}
                          key={index}
                          disabled={itsCompleted}
                          onClick={() => handleAnswerClick(index)}
                        >
                          <div className="inner">
                            <span className="oval" />
                            {answer?.textImage ? (
                              <>
                                <img src={answer.textImage.img} alt="" />
                                <p>{answer.textImage.text}</p>
                              </>
                            ) : gameQuestionsQuery.content[currentQuestion]
                                .imgAnswers ? (
                              <img
                                alt="answerIMG"
                                src={answer}
                                className="answerImg"
                              ></img>
                            ) : (
                              <p>{answer}</p>
                            )}
                          </div>
                        </button>
                      )}
                    </div>
                  )
                )}
              </div>
            </div>
            <a
              href={gameQuestionsQuery.content[currentQuestion]?.questDisLink}
              target="_blank"
              rel="noopener noreferrer"
              className="answer-dis"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(gameQuestionsQuery.content[currentQuestion]?.questDis),
              }}
            ></a>
          </div>
          <div className="side-img">
            <BrandLogo brands={gameQuestionsQuery?.brands} />
            {gameQuestionsQuery.content[currentQuestion].desktopImgHid ? (
              selected ===
              gameQuestionsQuery.content[currentQuestion].correctAnswer ? (
                <img
                  src={
                    gameQuestionsQuery.content[currentQuestion][
                      width < 1020 ? "mobileImg" : "desktopImg"
                    ]
                  }
                  alt=""
                />
              ) : (
                <img
                  src={
                    gameQuestionsQuery.content[currentQuestion][
                      width < 1020 ? "mobileImgHid" : "desktopImgHid"
                    ]
                  }
                  alt=""
                />
              )
            ) : (
              <div className="img-wrapper">
                <img
                  src={
                    gameQuestionsQuery.content[currentQuestion][
                      width < 1020 ? "mobileImg" : "desktopImg"
                    ]
                  }
                  alt=""
                />
                {gameQuestionsQuery.content[currentQuestion]?.sideImageCopy && (
                  <p
                    dangerouslySetInnerHTML={{
                      __html:
                        DOMPurify.sanitize(gameQuestionsQuery.content[currentQuestion]
                          ?.sideImageCopy),
                    }}
                  />
                )}
              </div>
            )}
            {XGA && (
              // replace "StickyContent" with something called respectively
              <StickyContent>
                <div className="desktop-buttons">
                  <Button
                    disabled={itsCompleted}
                    action={handleNextButtonClick}
                  >
                    {gameQuestionsQuery.content[currentQuestion]
                      .nextButtonCopy ?? "Nächste"}
                  </Button>
                </div>
              </StickyContent>
            )}
          </div>
        </div>
      </div>
      {!XGA && (
        // replace with "StickyContent"
        <StickyButton disabled={itsCompleted} action={handleNextButtonClick}>
          {gameQuestionsQuery.content[currentQuestion].nextButtonCopy ??
            "Nächste"}
        </StickyButton>
      )}
    </section>
  );
}
